module.exports = {"id":"217877","name":"Theo Bongonda","rating":"78","photo":"./data/images/photos/3/217877.png","club":{"name":"Zulte-Waregem","logo":"./data/images/clubs/Zulte-Waregem.png"},"positions":["AG","MG","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TheoBongonda0.json
// module id = 4088
// module chunks = 0